/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type {
  GetQuizsetRankingsParams,
  GetQuizsetRankingsSummaryParams,
  SuccessBodyAllPeriodsQuizsetRankingSummaryRes,
  SuccessBodyListSearchQuizsetRes,
} from '.././_model';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getQuizsetRankings = (
  params: GetQuizsetRankingsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListSearchQuizsetRes>(
    { url: `/quizsets/rankings`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizsetRankingsQueryKey = (
  params: GetQuizsetRankingsParams,
) => {
  return [`/quizsets/rankings`, ...(params ? [params] : [])] as const;
};

export const getGetQuizsetRankingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetRankingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetRankings>>
  > = ({ signal }) => getQuizsetRankings(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetRankings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizsetRankingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetRankings>>
>;
export type GetQuizsetRankingsQueryError = ErrorType<unknown>;

export function useGetQuizsetRankings<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetRankings>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetRankings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetRankings<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetRankings>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetRankings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizsetRankings<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizsetRankings<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizsetRankingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizsetRankingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetRankingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetRankings>>
  > = ({ signal }) => getQuizsetRankings(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetRankings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizsetRankingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetRankings>>
>;
export type GetQuizsetRankingsSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizsetRankingsSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetRankingsSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetRankingsSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizsetRankingsSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizsetRankingsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuizsetRankingsSummary = (
  params?: GetQuizsetRankingsSummaryParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyAllPeriodsQuizsetRankingSummaryRes>(
    { url: `/quizsets/rankings/summary`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizsetRankingsSummaryQueryKey = (
  params?: GetQuizsetRankingsSummaryParams,
) => {
  return [`/quizsets/rankings/summary`, ...(params ? [params] : [])] as const;
};

export const getGetQuizsetRankingsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetRankingsSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
  > = ({ signal }) => getQuizsetRankingsSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizsetRankingsSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
>;
export type GetQuizsetRankingsSummaryQueryError = ErrorType<unknown>;

export function useGetQuizsetRankingsSummary<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetQuizsetRankingsSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetRankingsSummary<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizsetRankingsSummary<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizsetRankingsSummary<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizsetRankingsSummaryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizsetRankingsSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetRankingsSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
  > = ({ signal }) => getQuizsetRankingsSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizsetRankingsSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
>;
export type GetQuizsetRankingsSummarySuspenseQueryError = ErrorType<unknown>;

export function useGetQuizsetRankingsSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetQuizsetRankingsSummaryParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetRankingsSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetRankingsSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizsetRankingsSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizsetRankingsSummarySuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
